import BaseModel from './base';

export default class UserPortfolio extends BaseModel {
  constructor(portfolio, url) {
    super(portfolio, url);

    this.owner_id = portfolio.owner_id;
    this.url = portfolio.url;
    this.original_name = portfolio.original_name;
    this.created_at = portfolio.created_at;
    this.description = portfolio.description;
    this.updated_at = portfolio.updated_at;
  }
}
